import { Injectable } from "@angular/core";
import { Observable, forkJoin } from "rxjs";
import { PaymentAjaxService } from "../../payment-system/services/payment-ajax.service";
import { mergeMap } from "rxjs/operators";
import * as _ from "underscore";
import { CASHIER_METHODS_NAME_EXTENSION, LOGO_EXTENSION, feesTypes } from "../config/cashier.config";
import { environment } from "../../../environments/environment";
import { EmitterService } from "../../services/emitter.service";
import { Utility } from "../../shared/utility/utility";

@Injectable({
  providedIn: "root",
})
export class CashierService {
  tokenData;
  piqMethodsList = [];
  customMethodsList = [];
  allCashierMethods = [];
  displayOrder = [];
  siteUrlPath = environment.siteUrl;
  mediaPath = environment.mediaPath;
  customCashierAmountInputs = [];
  isUserLoggedIn = false;
  isQuickDepositClicked = false;
  quickDepositSelectionAmount = 0;
  totalAmount=0;

  constructor(private paymentAjaxService: PaymentAjaxService, private emitterService:EmitterService, private utils:Utility) {
    this.emitterService.logoutAndLoginStatusUpdate$.subscribe(loginStatus => {
      this.resetData();
    });
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
   }

   resetData(){
    this.tokenData = null;
    this.piqMethodsList = [];
    this.customMethodsList = [];
    this.allCashierMethods = [];
    this.displayOrder = [];
    this.customCashierAmountInputs = [];
   }
  /*update cashier methods */
  updateCashierMethodsList(customMethods, piqMethods) {
    if ( customMethods && customMethods.length && piqMethods && piqMethods.length) {
         this.allCashierMethods = [];
          customMethods.filter((customMethod) => {
                piqMethods.filter((piqMethod) => {
                      if (!customMethod.isThirdparty && this.allCashierMethods.indexOf(customMethod) == -1) {
                        this.allCashierMethods.push(customMethod);
                      } else if (customMethod.name == piqMethod.name && customMethod.isThirdparty) {
                        this.allCashierMethods.push(piqMethod);
                      }
                });
          });
    }else if(customMethods && customMethods.length && (!piqMethods || !piqMethods.length)){
      customMethods.filter((customMethod) => {
        if(!customMethod.isThirdparty){
           this.allCashierMethods.push(customMethod);
        }
      })
    }
    //setting logo url
    this.allCashierMethods = this.updateCashierMethodsLogoUrl(this.allCashierMethods)
    //sort
    this.allCashierMethods = this.sortCashierMethods();
    return this.allCashierMethods;
  }
  updateCashierMethodsLogoUrl(cashierObj){
    cashierObj.map((item)=> {
      if(item && item.logoUrl && item.logoUrl.split('/').length == 1)
      item.logoUrl = this.siteUrlPath+'/'+this.mediaPath+'/'+'cashier_logos/'+item.logoUrl
    })
    return cashierObj;
  }
  // sort cashier final object based on displa order 
  sortCashierMethods() {
    let sortedArray = [];
    this.allCashierMethods.filter((method) => {
      this.displayOrder.filter((name) => {
        if (method.name == name) {
          sortedArray.push(method);
        }
      });
    });
    return sortedArray;
  }

  /*ALl Payments methds PIQ and Custom Methods from BO */
  getCashierDetails(userProfile: any, txnType: any): Observable<any> {
    return this.getTokenPaymentIQ().pipe(
      mergeMap((tokenData: any) => {
        if (tokenData && !tokenData["session_expired_sso"]) {
          this.tokenData = tokenData;
          /*Getting the methods from backoffice*/
          let cashierMethods = this.paymentAjaxService.getCashierData(txnType);
          /*Getting methods from paymentIQ*/
          let cashierPIQMethods = this.paymentIQMethods(
            tokenData,
            userProfile,
            txnType
          );
          return forkJoin([cashierMethods, cashierPIQMethods]);
        }
        return "";
      })
    );
  }

  getPnpCashierConfigData(txnType){
    return this.paymentAjaxService.getCashierData(txnType);
  }

  /*cashier Toker*/
  getTokenPaymentIQ(): Observable<any> {
    return this.paymentAjaxService.getTokenPaymentIQ("cashier");
  }

  /*Payment IQ Methods*/
  paymentIQMethods(tokenData: any, userProfile: any, method): Observable<any> {
    let credentials = {
      sessionId: tokenData.token,
      method: method,
    };
    return this.paymentAjaxService.getPaymentIQmethods(
      credentials,
      userProfile.playerID
    );
  }
  /*Return Cashier methods custom object*/
  getCashierMethodsObject(methdsArray: any) {
    return this.getCustomCashierMethodsList(methdsArray);
  }
  getCustomCashierMethodsList(methdsArray) {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    if(this.isUserLoggedIn){
      let customMethodsObj = methdsArray[0];
      let piqMethodsObj = methdsArray[1];
      return this.filterMethods(customMethodsObj, piqMethodsObj);
    }else{
      return this.filterMethods(methdsArray, []);
    }
    
  }

  filterMethods(customMethodsObj, piqMethodsObj) {
    let self = this;

    if (piqMethodsObj && piqMethodsObj.methods && piqMethodsObj.methods.length) {
      self.filterPiqMethds(piqMethodsObj);
    }

    if (customMethodsObj && customMethodsObj.cashierData && customMethodsObj.cashierData.depositMethods && Object.keys(customMethodsObj.cashierData.depositMethods)) {
      let customCashierMethods = customMethodsObj.cashierData.depositMethods;
      this.displayOrder = customMethodsObj.cashierData.displayOrder ? customMethodsObj.cashierData.displayOrder : [];
      self.filterCustomCashierMethods(customCashierMethods);
    }
    if(this.isUserLoggedIn){
      return this.updateCashierMethodsList(this.customMethodsList,this.piqMethodsList);
    }
    return this.customMethodsList;
  }

  filterCustomCashierMethods(customCashierMethods) {
    let self = this;
    this.customMethodsList = [];
    Object.values(customCashierMethods).forEach((method: any) => {
      let cashierMethod: any = {};

      cashierMethod.name = method.methodName;
      cashierMethod.jsonKey = 'paymentMethods.'+method.methodName;
      cashierMethod.isThirdparty = method.isThirdparty == "Yes" ? true : false;
      cashierMethod.updatedTime = method.updatedTime;
      cashierMethod.logoUrl = '';
      cashierMethod.logoUrl = method.methodName + LOGO_EXTENSION;

      cashierMethod = this.setLimitsForCashierMethod(method,cashierMethod);

      self.customMethodsList.push(cashierMethod);
    });
  }

  setLimitsForCashierMethod(method,cashierMethod){
    if(method && method.limits) {
      cashierMethod.feeAmount = method.limits.feeAmount ? method.limits.feeAmount : "0";
      cashierMethod.feeType = method.limits.feeType;
      cashierMethod.minAmount = method.limits.minTxnLimit ? method.limits.minTxnLimit : 0;
      cashierMethod.maxAmount = method.limits.maxTxnLimit ? method.limits.maxTxnLimit : 0;
      cashierMethod.minFeesAmount = method.limits.minFeeAmount ? method.limits.minFeeAmount : 0;
      cashierMethod.maxFeesAmount = method.limits.maxFeeAmount ? method.limits.maxFeeAmount : 0;
    }else{
      cashierMethod.feeAmount = 0;
      cashierMethod.feeType = 'none';
      cashierMethod.minAmount = 0;
      cashierMethod.maxAmount = 0;
    }
    return cashierMethod;
  }
  filterPiqMethds(piqMethodsObj) {
    let self = this;
    let piqMethods = piqMethodsObj.methods;
    this.piqMethodsList = [];
    piqMethods.filter((method) => {
      if (method) {
        let cashierPiqMethod: any = {};
        cashierPiqMethod.name =this.getNameFromMethodObj(method);
        cashierPiqMethod.jsonKey ='paymentMethods.'+this.getNameFromMethodObj(method);
        
        cashierPiqMethod.providerType = method.providerType;
        cashierPiqMethod.service = method.service;
        cashierPiqMethod.logoUrl="";
        cashierPiqMethod.logoUrl = cashierPiqMethod.name + LOGO_EXTENSION;
        cashierPiqMethod.accounts = method?.accounts ? method?.accounts : [] ;

        //set fees and fee type
        cashierPiqMethod = this.setTransactionFeesDetails(method,cashierPiqMethod);

        // set min max amount of deposit
        cashierPiqMethod = this.setMinMaxValues(method, cashierPiqMethod);

        /* data is coming from PIQ so we can directly binding the value isThirdparty true*/
        cashierPiqMethod.isThirdparty = true;
        
        self.piqMethodsList.push(cashierPiqMethod);
      }
    });
  }

  setTransactionFeesDetails(method,cashierPiqMethod){
    if (method && method.fees && method.fees.length) {
      if (method.fees[0].useFixedAndPercentageFee) {
        cashierPiqMethod.feeAmount = method.fees[0]?.fixedFeeMin;
        cashierPiqMethod.feeType = feesTypes.FEES_TYPE_ABSOLUTE;
      } else {
        cashierPiqMethod.feeAmount = method.fees[0] ? (method.fees[0].percentageFee * 100): 0;  //Multiplying with 100 because paymentiq is giving the percentage value already. 
        cashierPiqMethod.feeType = feesTypes.FEES_TYPE_PERCENTAGE;
      }
    } else {
      cashierPiqMethod.feeAmount = "0";
      cashierPiqMethod.feeType = feesTypes.FEES_TYPE_NONE;
    }
    return cashierPiqMethod;
  }
  // Set min max values 
  setMinMaxValues(method,cashierPiqMethod){
    if(method.limit && method.limit.max && method.limit.min) {
      cashierPiqMethod.minAmount = method.limit.min ? method.limit.min:0;
      cashierPiqMethod.maxAmount = method.limit.max ? method.limit.max: 0;
    }else{
      cashierPiqMethod.minAmount = 0;
      cashierPiqMethod.maxAmount = 0;
    }
    return cashierPiqMethod;
  }

  /*  Update custom name */
  getNameFromMethodObj(method) {
    let name = method.providerType;
    name = method.service ? name + "-" + method.service + CASHIER_METHODS_NAME_EXTENSION : name + CASHIER_METHODS_NAME_EXTENSION;
    return name;
  }

  getCashierAmountConfig(type, currency){
    return this.paymentAjaxService.getCashierAmountConfig(type, currency);
  }

}
